import React, { useState, useEffect, useRef } from "react";
import { postDataFetcher } from "../../dataFetcher";
import { withTranslation } from "react-i18next";
import "./baby-name-finder-css/baby-name-finder.css";
import { isMobile } from "react-device-detect";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import CONFIG_OBJECT from "../../config/config";
import App_Constants from "../../app-constants/App_Constants";
import Loader from "./Loader/index";
import Results from "./Results/Results";
import Error from "./Error/Error";
import FirstNameForm from "./first-name-tab/FirstNameForm";
import "./filters/gender-drop-down.css";
import "./filters/origin-drop-down.css";

let selectedTab = {
    key: "FIRST_NAME",
};

let filterList = [];
let selectedOriginFilterList = [];

const defaultitemperpage = 10;

let searchData = {
    searchType: "searchbyname",
    searchTerm: "",
    currentPage: 1,
    itemsPerPage: 10,
};

const BabyNameSearchResult = (props) => {
    const [originString, setOriginString] = useState("");
    const [apidata, setApidata] = useState({
        data: "",
        totalCount: 1,
        itemsPerPage: 10,
        numberOfPages: 1,
        currentPage: 1,
        result: [],
        relatedItems: [],
        relatedItemsBlk: false,
        filtergroup: "",
    });
    const [autoNames, setAutoNames] = useState([]);
    const [searchfieldText, setSearchfieldtext] = useState({
        text: sessionStorage.getItem("searchText") || "",
        resultdata: "",
    });
    const [searchTypeResulMsg, setSearchTypeResulMsg] = useState({});

    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState();
    const [filterlist, setFilterlist] = useState([]);
    const [genderFilterData, setGenderFilterData] = useState([]);
    const [originFilterData, setOriginFilterData] = useState([]);

    const [tabData, setTabData] = useState({
        showFirstNameForm: false,
        showMiddleNameForm: false,
        data: {},
    });
    const [showMiddleNameDesc, setShowMiddleNameDesc] = useState(true);

    const [componentData, setComponentData] = useState({});
    const [hideResult, setHideResult] = useState(false);
    const [showAllBabyNames, setShowAllBabyNames] = useState(false);

    const [counter, setCounter] = useState(0);
    const [showItems, setShowItems] = useState(false);
    const [defaultGenderPlaceHolder, setDefaultGenderPlaceHolder] = useState("");
    // genderItem : getting it from layout response to show options in Gender filter dropdown
    const [genderItem, setGenderItem] = useState([]);
    // genderFilterList : list of all selected filter
    const [genderFilterList, setGenderFilterList] = useState(
        JSON.parse(sessionStorage.getItem("genderFilterList")) || []
    );

    const [showOriginItems, setShowOriginItems] = useState(false);
    const [defaultSearchType, setDefaultSearchType] = useState("");
    const [originItem, setOriginItem] = useState([]);
    const [originFilterList, setOriginFilterList] = useState(
        JSON.parse(sessionStorage.getItem("originFilterList")) || []
    );

  // Calling Layout Service and Caching the response
  useEffect(() => {
    // document.addEventListener('click', closeFiltersDropDwons);
    sessionStorage.removeItem("genderFilterList");
    sessionStorage.removeItem("originFilterList");
    sessionStorage.removeItem("pageperitem");
    sessionStorage.removeItem("favNames");
    sessionStorage.removeItem("searchText");
    sessionStorage.setItem("currentPage", 1);
    let componentData = props.fields;
    let defaultItemsPerPage =
      componentData.pageSize && componentData.pageSize[0].fields.key.value;
    sessionStorage.setItem("pageperitem", Number(defaultItemsPerPage));
    setComponentData(componentData);
    setTabData({
      showFirstNameForm: true,
      data: componentData.searchTabs[0].fields,
    });
    setShowMiddleNameDesc(false);
    setDefaultGenderPlaceHolder(
      componentData.filters[0].fields.placeholderLabel.value
    );
    setGenderItem(componentData.filters[0].fields.filterItems);
    setGenderFilterList([]);
    setDefaultSearchType(
      componentData.filters[1].fields.placeholderLabel.value
    );
    setOriginItem(componentData.filters[1].fields.filterItems);
    setOriginFilterList([]);
  }, []);

  const loadAllBabyNames = () => {
    let componentData = props.fields;
    let data = {
      pagenumber:
        sessionStorage.getItem("currentPage") || searchData.currentPage,
      itemsPerPage:
        sessionStorage.getItem("pageperitem") || searchData.itemsPerPage,
    };
    if (
      (searchData.genderslist != null && searchData.genderslist.length > 0) ||
      (searchData.originlist != null && searchData.originlist.length > 0)
    ) {
      data = {
        pagenumber:
          sessionStorage.getItem("currentPage") || searchData.currentPage,
        itemsPerPage:
          sessionStorage.getItem("pageperitem") || searchData.itemsPerPage,
        GendersList: searchData.genderslist,
        OriginsList: searchData.originlist,
      };
    }
    setPageSize(props.fields.pageSize && props.fields.pageSize);
    let resUrl = `${CONFIG_OBJECT.ALL_BABY__NAMES_REST_URL}`;
    postDataFetcher(
      `${resUrl}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem(
        "language"
      )}`,
      data
    ).then(
      (res) => {
        if (res.data.HasError) {
          console.log(res.data.HasError);
        } else {
          updateGenderItemWithCount(genderItem, res.data.Data.filters);
          updateOroginItemWithCount(originItem, res.data.Data.filters);
          if (res.data.Data.pagination !== null) {
            let genderFiltersItem = componentData.filters[0].fields.filterItems;
            res.data.Data.babyNames.map((item) => {
              let checkItem = genderFiltersItem.filter((g_item) => {
                if (g_item.id === item.genderIds[0]) {
                  return g_item;
                }
              });
              if (checkItem.length > 0) {
                item.genderImage = checkItem[0].fields.logo.value;
              }
            });
            console.log(JSON.parse(sessionStorage.getItem("favNames")));
            if (sessionStorage.getItem("favNames")) {
              let favNames = JSON.parse(sessionStorage.getItem("favNames"));
              res.data.Data.babyNames.map((item) => {
                let checkFavItem = favNames.filter((f_item) => {
                  if (
                    f_item.firstName === item.firstName &&
                    f_item.middleName === item.middleName &&
                    f_item.isFav
                  ) {
                    return f_item;
                  }
                });
                if (checkFavItem.length > 0) {
                  item.isFav = true;
                }
              });
            }
            setLoader(false);
            setHideResult(true);
            setApidata({
              data: res.data.Data,
              totalCount: res.data.Data.pagination.totalCount,
              itemsPerPage: res.data.Data.pagination.itemsPerPage,
              numberOfPages: res.data.Data.pagination.numberOfPages,
              currentPage: res.data.Data.pagination.currentPage,
              result: res.data.Data.babyNames,
              relatedItemsBlk: false,
              filtergroup: res.data.Data.filters,
            });

                        if (searchfieldText.text != "") {
                            setSearchfieldtext({
                                text: "",
                                resultdata: "",
                            });
                        }
                        setSearchTypeResulMsg(searchData.searchObject);
                        setShowAllBabyNames(true);
                    } else {
                        setLoader(false);
                        setHideResult(true);
                        setApidata({
                            data: "",
                            totalCount: 0,
                            itemsPerPage: defaultitemperpage,
                            numberOfPages: 1,
                            currentPage: 1,
                            result: null,
                            relatedItemsBlk: true,
                            filtergroup: null,
                        });
                    }
                }
            },
            (err) => {
                setLoader(false);
                setHideResult(false);
                console.log(err);
            }
        );
    };

    useEffect(() => {
        if (
            tabData.showFirstNameForm &&
            (sessionStorage.getItem("searchText") === null ||
                sessionStorage.getItem("searchText") === "")
        ) {
            loadAllBabyNames();
            sessionStorage.setItem("enableCloseButton", false);
        }
    }, [
            sessionStorage.getItem("currentPage"),
            sessionStorage.getItem("pageperitem"),
            sessionStorage.getItem("searchText"),
            tabData.showFirstNameForm,
            searchData.genderslist,
            searchData.originlist,
        ]);

    useEffect(() => {
        if (
            tabData.showFirstNameForm &&
            (sessionStorage.getItem("searchText") === null ||
                sessionStorage.getItem("searchText") === "")
        ) {
            loadAllBabyNames();
        }
    }, []);

    useEffect(() => {
        if (
            tabData.showFirstNameForm &&
            sessionStorage.getItem("searchText") != null &&
            sessionStorage.getItem("searchText") != "" &&
            sessionStorage.getItem("searchText").length > 1 &&
            ((searchData.genderslist != null && searchData.genderslist.length > 0) ||
                (searchData.originlist != null && searchData.originlist.length > 0))
        ) {
            sessionStorage.setItem("enableCloseButton", true);
        }
    }, [
            searchData.genderslist,
            searchData.originlist,
            sessionStorage.getItem("searchText"),
        ]);

    useEffect(() => {
        if (counter !== 0) {
            setGenderItem(genderItem);
            setGenderFilterList(genderFilterList);
            setOriginItem(originItem);
            setOriginFilterList(originFilterList);
        }
    }, [counter]);

    const closeFiltersDropDwons = (event) => {
        console.log(event.target.className);
        if (
            event.target.className ===
            "select-box--selected-item-gender border-highlighted"
        ) {
            setShowItems(true);
        } else if (
            event.target.className === "custom-checkbox" ||
            event.target.className.trim() === "" ||
            event.target.className === "btn btn-clear" ||
            event.target.className === "nameListItem"
        ) {
            setShowItems(true);
        } else if (event.target.className !== "select-box--selected-item-gender") {
            setShowItems(false);
        }
    };

    const dropDown = () => {
        // if (props.searchString.length === 0) setShowItems(false)
        // else
        setShowItems(!showItems);
        setShowOriginItems(false);
    };

    const originDropDown = () => {
        // if (props.searchString.length === 0) setShowItems(false)
        // else
        setShowOriginItems(!showOriginItems);
        setShowItems(false);
        setOriginString("");
    };

    const closeOriginDropDown = () => {
        setShowOriginItems(false);
        setShowItems(false);      
    };

    const closeDropDown = () => {
        setShowItems(false);      
    };

    // In this method dynamically updating 'genderItem' based on the selection of particular checkbox
    const selectItem = (item) => {
        // Creating an Array that contains the checked/selected options
        // initially filterList is kept blank
        let checkItem = []; // this is a temp variable to check already present item in filterList array

        if (filterList.length === 0) {
            //if filterList is blank then simply push whatever is selected
            filterList.unshift(item);
        } else {
            // if filterList is not blank, then we are cheking if that element is already
            // present or not means same item can be de-selected after selection
            checkItem = filterList.filter((f_item) => {
                if (f_item.id === item.id) {
                    return f_item;
                }
            });
            // checkItem.length === 0 means that element is not found, means its a new element
            // we need to push the element in filterList Array
            if (checkItem.length === 0) {
                filterList.unshift(item);
            }
            // if length is not 0 then means its not a new element was selected earlier
            // now user has deselected that, so we need to remove that
            else if (checkItem.length > 0) {
                // we are iterating over the filterList and having a check where selected element id is not equal to items
                checkItem = filterList.filter((f_item) => {
                    if (f_item.id !== item.id) {
                        return f_item;
                    }
                });
                // So now we are having only selected element
                filterList = checkItem;
                // we had simply assign it to filterList : we will update the actual filterlist once user clicks on 'Done' button
            }
            // console.log(checkItem)
        }
        // Setting filterList here to be show in selected filter bar
        setGenderFilterList(filterList);
        sessionStorage.setItem("genderFilterList", JSON.stringify(filterList));
        sessionStorage.setItem("currentPage", 1);
        getGenderFilters(filterList);

        // After having the selected filterlist, we need to update the 'genderItem' dynamically
        genderItem.map((gitem) => {
            if (gitem.id === item.id) {
                gitem.fields.selectbyDefault.value = !gitem.fields.selectbyDefault
                    .value;
            }
            return gitem;
        });
        // Dynamically updating selected/unselected states of options
        setGenderItem(genderItem);
        // counter is being updated for component to be reloaded
        setCounter(counter + 1);
        searchData.searchTerm = sessionStorage.getItem("searchText");
        setSearchfieldtext({
            text: searchData.searchTerm,
        });
    };

    const clearAllGender = () => {
        // isClearAll = true
        genderItem.map((gitem) => {
            // if(gitem.id === item.id){
            gitem.fields.selectbyDefault.value = false;
            // }
            return gitem;
        });
        filterList = [];
        setGenderFilterList([]);
        setGenderItem(genderItem);
        setCounter(counter + 1);
        getGenderFilters([]);
        sessionStorage.setItem("genderFilterList", JSON.stringify([]));
    };

    const removeGenderItem = (item) => {
        // console.log(item)
        genderItem.map((gitem) => {
            if (gitem.id === item.id) {
                gitem.fields.selectbyDefault.value = false;
                return gitem;
            } else {
                return gitem;
            }
        });
        let tempFilterList = filterList.filter((fitem) => {
            if (fitem.id !== item.id) {
                return fitem;
            }
        });
        filterList = tempFilterList;
        setGenderFilterList(tempFilterList);
        getGenderFilters(tempFilterList);
        sessionStorage.setItem("genderFilterList", JSON.stringify(tempFilterList));
        setGenderItem(genderItem);
        setCounter(counter + 1);
        if (tempFilterList.length === 0) {
            loadAllBabyNames();
        }
        // console.log('genderitem at time of removing item',genderItem)
    };

    const paginate = (pagenumber) => {
        setApidata({
            ...apidata,
            currentPage: pagenumber,
        });
        sessionStorage.setItem("currentPage", parseInt(pagenumber));
        searchData.currentPage = parseInt(pagenumber);
        if (searchData.searchTerm != null && searchData.searchTerm.length !== 0) {
            getNames();
        }
    };

    const itemsperpage = (itemcount) => {
        setApidata({
            ...apidata,
            itemsPerPage: itemcount,
            currentPage: 1,
        });
        searchData.currentPage = 1;
        searchData.itemsPerPage = parseInt(itemcount);
        getNames();
    };

    const { t } = props;

    const mySubmitHandler = (e) => {
        e.preventDefault();
    };

    const setTab = (item) => {
        selectedTab.key = item.key.value;
        // console.log(selectedTab.key)
        if (selectedTab.key === "FIRST_NAME") {
            setTabData({
                showFirstNameForm: true,
                showMiddleNameForm: false,
                data: item,
            });
            setShowMiddleNameDesc(false);
            setShowAllBabyNames(true);
        } else {
            setTabData({
                showFirstNameForm: false,
                showMiddleNameForm: true,
                data: item,
            });
            setShowMiddleNameDesc(true);
            setShowAllBabyNames(false);
            sessionStorage.setItem(
                "FirstTab_PreviousSearchTerm",
                searchData.searchTerm
            );
        }
    setHideResult(true);

  //  Resetting filters on change of Tab
  //   sessionStorage.removeItem("genderFilterList");
  //   sessionStorage.removeItem("originFilterList");
  //  //searchData.searchTerm = "";
  //   clearAllOrigins();
  //   clearAllGender();
  };

    const getSearchType = (searchtype) => {
        searchData.searchObject = searchtype;
        searchData.searchtype = searchtype.key.value;
        // searchData.pagenumber = 1
        // console.log(searchtype.key.value);
        //setSearchTypeResulMsg(searchData.searchObject)
    };

    const getSearchText = (searchText, yearValue) => {
        searchData.searchTerm = searchText;
        searchData.yearValue = yearValue;
        sessionStorage.setItem("searchText", searchText);
        // console.log(searchText);
        setSearchfieldtext({
            text: searchText,
        });
        if (searchData.searchTerm.length !== 0) {
            getNames();
        }
    };

    const getGenderFilters = (genderFilterList) => {
        let genderList = [];
        // console.log(genderFilterList)
        for (let i = 0; i < genderFilterList.length; i++) {
            genderList.push(`{${genderFilterList[i].id}}`);
        }

        searchData.genderslist = JSON.stringify(genderList);
        if (searchData.searchTerm && searchData.searchTerm.length !== 0) {
            getNames();
        }
        setGenderFilterData(genderFilterList);
    };

    const getOriginFilters = (originFilterList) => {
        let originList = [];
        // console.log(originFilterList)
        for (let i = 0; i < originFilterList.length; i++) {
            originList.push(`{${originFilterList[i].id}}`);
        }

        searchData.originlist = JSON.stringify(originList);
        if (searchData.searchTerm && searchData.searchTerm.length !== 0) {
            getNames();
        }
        setOriginFilterData(originFilterList);
    };

    useEffect(() => {
        if (
            searchfieldText.text != null &&
            searchfieldText.text != "" &&
            searchfieldText.text.length > 1
        ) {
            getAutoSuggestNames(searchfieldText.text);
            if (
                (searchData.genderslist != null && searchData.genderslist.length > 0) ||
                (searchData.originlist != null && searchData.originlist.length > 0)
            ) {
                getNames();
            }
        }
    }, [searchData.genderslist, searchData.originlist]);

    const getAutoSuggestNames = (autosuggestText) => {
        // console.log(autosuggestText)
        setSearchTypeResulMsg(searchData.searchObject);
        // setLoader(true)
        setPageSize(props.fields.pageSize && props.fields.pageSize);
        let resUrl = `${CONFIG_OBJECT.BABY_AUTO_NAME_FINDER_REST_URL}`;
        // if (searchData.searchtype === 'searchformiddlenames') {
        //   resUrl = `${CONFIG_OBJECT.BABY_MIDDLE_NAME_FINDER_REST_URL}`
        // }
        let data = {
            searchtype: searchData.searchtype,
            searchTerm: autosuggestText,
            pagenumber: 1,
            itemsPerPage: searchData.itemsPerPage,
            genderslist: searchData.genderslist || [],
            originslist: searchData.originlist || [],
        };
        postDataFetcher(
            `${resUrl}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem(
                "language"
            )}`,
            data
        ).then(
            (res) => {
                if (res.data.HasError) {
                    console.log(res.data.HasError);
                } else {
                    // console.log(res.data.Data)
                    setAutoNames(res.data.Data);
                }
            },
            (err) => {
                setLoader(false);
                console.log(err);
            }
        );
    };

    const getNames = () => {
        // console.log('clicked')
        setSearchTypeResulMsg(searchData.searchObject);
        setLoader(true);
        setPageSize(props.fields.pageSize && props.fields.pageSize);
        let resUrl = `${CONFIG_OBJECT.BABY_NAME_FINDER_REST_URL}`;
        if (searchData.searchtype === "searchformiddlenames") {
            resUrl = `${CONFIG_OBJECT.BABY_MIDDLE_NAME_FINDER_REST_URL}`;
            setShowMiddleNameDesc(false);
        }

        let data = {
            searchtype: searchData.searchtype,
            searchTerm: sessionStorage.getItem("searchText") || searchData.searchTerm,
            pagenumber:
                sessionStorage.getItem("currentPage") || searchData.currentPage,
            itemsPerPage:
                sessionStorage.getItem("pageperitem") || searchData.itemsPerPage,
            genderslist: searchData.genderslist || [],
            originslist: searchData.originlist || [],
        };

        if (searchData.searchtype === "searchbyyear") {
            resUrl = `${CONFIG_OBJECT.POPULAR_NAMES_BY_YEAR_REST_URL}`;
            data = {
                PopularYear:
                    sessionStorage.getItem("searchText") || searchData.searchTerm,
                PageNumber:
                    sessionStorage.getItem("currentPage") || searchData.currentPage,
                ItemsPerPage:
                    sessionStorage.getItem("pageperitem") || searchData.itemsPerPage,
                GendersList: searchData.genderslist || [],
                OriginsList: searchData.originlist || [],
            };
        }

        if (
            searchData.searchtype === "searchbyyear" &&
            (Number(searchData.searchTerm) >
                Number(t("BabyNameFinder_SearchByYearInputMaxValue")) ||
                Number(searchData.searchTerm) <
                Number(t("BabyNameFinder_SearchByYearInputMinValue")))
        ) {
            setLoader(false);
            setHideResult(true);
            setApidata({
                error: { value: t("BabyNameFinder_SearchByYearInputRangeMsg") },
                data: { isFullMatch: false },
            });
        } else {
            postDataFetcher(
                `${resUrl}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem(
                    "language"
                )}`,
                data
            ).then(
                (res) => {
                    if (res.data.HasError) {
                        console.log(res.data.HasError);
                    } else {
                        updateGenderItemWithCount(genderItem, res.data.Data.filters);
                        updateOroginItemWithCount(originItem, res.data.Data.filters);
                        if (res.data.Data.pagination !== null) {
                            if (searchData.searchtype === "searchformiddlenames") {
                                res.data.Data.babyNames = res.data.Data.middleNames;
                            }
                            let genderFiltersItem =
                                componentData.filters[0].fields.filterItems;
                            if (searchData.searchtype === "searchbyyear") {
                                res.data.Data.PopularBabyNames.map((item) => {
                                    let checkItem = genderFiltersItem.filter((g_item) => {
                                        if (g_item.id === item.genderIds[0]) {
                                            return g_item;
                                        }
                                    });
                                    // console.log(checkItem)
                                    if (checkItem.length > 0) {
                                        item.genderImage = checkItem[0].fields.logo.value;
                                    }
                                    if (searchData.searchtype !== "searchformiddlenames") {
                                        item.middleName = "";
                                    }
                                });
                            } else {
                                res.data.Data.babyNames.map((item) => {
                                    let checkItem = genderFiltersItem.filter((g_item) => {
                                        if (g_item.id === item.genderIds[0]) {
                                            return g_item;
                                        }
                                    });
                                    // console.log(checkItem)
                                    if (checkItem.length > 0) {
                                        item.genderImage = checkItem[0].fields.logo.value;
                                    }
                                    if (searchData.searchtype !== "searchformiddlenames") {
                                        item.middleName = "";
                                    }
                                });
                            }
                            console.log(JSON.parse(sessionStorage.getItem("favNames")));
                            if (sessionStorage.getItem("favNames")) {
                                let favNames = JSON.parse(sessionStorage.getItem("favNames"));
                                if (searchData.searchtype === "searchbyyear") {
                                    res.data.Data.PopularBabyNames.map((item) => {
                                        let checkFavItem = favNames.filter((f_item) => {
                                            if (
                                                f_item.firstName === item.firstName &&
                                                f_item.middleName === item.middleName &&
                                                f_item.isFav
                                            ) {
                                                return f_item;
                                            }
                                        });
                                        if (checkFavItem.length > 0) {
                                            item.isFav = true;
                                        }
                                    });
                                } else {
                                    res.data.Data.babyNames.map((item) => {
                                        let checkFavItem = favNames.filter((f_item) => {
                                            if (
                                                f_item.firstName === item.firstName &&
                                                f_item.middleName === item.middleName &&
                                                f_item.isFav
                                            ) {
                                                return f_item;
                                            }
                                        });
                                        if (checkFavItem.length > 0) {
                                            item.isFav = true;
                                        }
                                    });
                                }
                            }
                            setLoader(false);
                            setHideResult(true);
                            setApidata({
                                data: res.data.Data,
                                totalCount: res.data.Data.pagination.totalCount,
                                itemsPerPage: res.data.Data.pagination.itemsPerPage,
                                numberOfPages: res.data.Data.pagination.numberOfPages,
                                currentPage: res.data.Data.pagination.currentPage,
                                result:
                                    searchData.searchtype === "searchbyyear"
                                        ? res.data.Data.PopularBabyNames
                                        : res.data.Data.babyNames,
                                relatedItemsBlk: false,
                                filtergroup: res.data.Data.filters,
                            });
                            setShowAllBabyNames(false);
                        } else {
                            setLoader(false);
                            setHideResult(true);
                            setApidata({
                                data: "",
                                totalCount: 0,
                                itemsPerPage: defaultitemperpage,
                                numberOfPages: 1,
                                currentPage: 1,
                                result: null,
                                relatedItemsBlk: true,
                                filtergroup: null,
                            });
                        }
                    }
                },
                (err) => {
                    // if (searchData.searchtype === 'searchbyyear') {
                    //   setLoader(false)
                    //   setHideResult(true)
                    //   // setApidata({
                    //   //   error: err.data.Data.Error,
                    //   // })
                    // } else {
                    setLoader(false);
                    setHideResult(false);
                    // }
                    console.log(err);
                }
            );
        }
    };

    const updateGenderItemWithCount = (genderItem, response) => {
        // console.log(genderItem);
        // console.log(genderResponse[0].filterItems);
        if (response != null) {
            let genderResponse = response.filter((filter) => {
                if (filter.filterGroupName === "gender") return filter;
            });

            genderItem.map((g_item, index) => {
                let getElement = genderResponse[0].filterItems.filter((item) => {
                    if (item.filterItemID === g_item.id) return item;
                });
                console.log(getElement);
                if (getElement[0] != null)
                    g_item.fields.count =
                        getElement[0].filterItemCount != undefined
                            ? getElement[0].filterItemCount
                            : 0;
            });
        } else {
            genderItem.map((g_item, index) => {
                g_item.fields.count = 0;
            });
        }

        // console.log(genderItem)
        setGenderItem(genderItem);
    };

    const updateOroginItemWithCount = (originItem, response) => {
        // console.log(originItem);
        // console.log(originResponse[0].filterItems);
        if (response != null) {
            let originResponse = response.filter((filter) => {
                if (filter.filterGroupName === "origin") return filter;
            });

            originItem.map((g_item, index) => {
                let getElement = originResponse[0].filterItems.filter((item) => {
                    if (item.filterItemID === g_item.id) return item;
                });
                console.log(getElement);
                if (getElement[0] != null) {
                    console.log(
                        getElement[0].filterItemName + ": " + getElement[0].filterItemCount
                    );
                    g_item.fields.count =
                        getElement[0].filterItemCount != undefined
                            ? getElement[0].filterItemCount
                            : 0;
                }
                else{
                    g_item.fields.count =0;
                }
            });
        } else {
            originItem.map((g_item, index) => {
                g_item.fields.count = 0;
            });
        }

        // console.log(originItem)
        setOriginItem(originItem);
    };

    // In this method dynamically updating 'originItem' based on the selection of particular checkbox
    const selectOriginItem = (item) => {
        // Creating an Array that contains the checked/selected options
        // initially filterList is kept blank
        let checkItem = []; // this is a temp variable to check already present item in filterList array

        if (selectedOriginFilterList.length === 0) {
            //if filterList is blank then simply push whatever is selected
            selectedOriginFilterList.unshift(item);
        } else {
            // if filterList is not blank, then we are cheking if that element is already
            // present or not means same item can be de-selected after selection
            checkItem = selectedOriginFilterList.filter((f_item) => {
                if (f_item.id === item.id) {
                    return f_item;
                }
            });
            // checkItem.length === 0 means that element is not found, means its a new element
            // we need to push the element in filterList Array
            if (checkItem.length === 0) {
                selectedOriginFilterList.unshift(item);
            }
            // if length is not 0 then means its not a new element was selected earlier
            // now user has deselected that, so we need to remove that
            else if (checkItem.length > 0) {
                // we are iterating over the filterList and having a check where selected element id is not equal to items
                checkItem = selectedOriginFilterList.filter((f_item) => {
                    if (f_item.id !== item.id) {
                        return f_item;
                    }
                });
                // So now we are having only selected element
                selectedOriginFilterList = checkItem;
                // we had simply assign it to filterList : we will update the actual filterlist once user clicks on 'Done' button
            }
            // console.log(checkItem)
        }
        // console.log('creating filter list while cheking checkbozes',filterList);
        // Setting filterList here to be show in selected filter bar
        setOriginFilterList(selectedOriginFilterList);
        sessionStorage.setItem(
            "originFilterList",
            JSON.stringify(selectedOriginFilterList)
        );
        sessionStorage.setItem("currentPage", 1);
        getOriginFilters(selectedOriginFilterList);
        // console.log(originItem)

        // After having the selected filterlist, we need to update the 'originItem' dynamically
        originItem.map((gitem) => {
            if (gitem.id === item.id) {
                gitem.fields.selectbyDefault.value = !gitem.fields.selectbyDefault
                    .value;
            }
            return gitem;
        });
        // Dynamically updating selected/unselected states of options
        setOriginItem(originItem);
        // counter is being updated for component to be reloaded
        setCounter(counter + 1);
        searchData.searchTerm = sessionStorage.getItem("searchText");
        setSearchfieldtext({
            text: searchData.searchTerm,
        });
    };

    const clearAllOrigins = () => {
        // isClearAll = true
        originItem.map((gitem) => {
            // if(gitem.id === item.id){
            gitem.fields.selectbyDefault.value = false;
            // }
            return gitem;
        });
        selectedOriginFilterList = [];
        setOriginFilterList([]);
        setOriginItem(originItem);
        setCounter(counter + 1);
        getOriginFilters([]);
        setOriginString("");
        sessionStorage.setItem("originFilterList", JSON.stringify([]));
    };

    const removeOriginItem = (item) => {
        // console.log(item)
        originItem.map((gitem) => {
            if (gitem.id === item.id) {
                gitem.fields.selectbyDefault.value = false;
                return gitem;
            } else {
                return gitem;
            }
        });
        let tempFilterList = selectedOriginFilterList.filter((fitem) => {
            if (fitem.id !== item.id) {
                return fitem;
            }
        });
        selectedOriginFilterList = tempFilterList;
        setOriginFilterList(tempFilterList);
        getOriginFilters(tempFilterList);
        sessionStorage.setItem("originFilterList", JSON.stringify(tempFilterList));
        setOriginItem(originItem);
        setCounter(counter + 1);
        if (tempFilterList.length === 0) {
            loadAllBabyNames();
        }
        // console.log('originItem at time of removing item',originItem)
    };

    const clearAllFilters = () => {
        // setLoader(true);
        setHideResult(false);
        // console.log('Clearing all filters')
        sessionStorage.removeItem("genderFilterList");
        sessionStorage.removeItem("originFilterList");
        clearAllOrigins();
        clearAllGender();
        loadAllBabyNames();
        // setCounter(counter + 1)
        // window.location.reload()
    };

    const handleChange = (e) => {
        // console.log(e.target.value)
        setOriginString(e.target.value);
    };

    // Clearing all result on clickon of 'X' button from text box
    const clearTextWithResult = () => {
        setLoader(true);
        setHideResult(false);
        setTimeout(function () {
            setLoader(false);
        }, 1000);
    };

    const restrictSpecialChar = (e) => {
        var key = e.keyCode ? e.keyCode : e.which;
        if (e.target.value.length > 29) e.preventDefault();
        if (
            !(
                (key >= 48 && key <= 57) ||
                (key >= 65 && key <= 90) ||
                (key >= 97 && key <= 122)
            ) &&
            key != 8 &&
            key != 32
        )
            e.preventDefault();
        if (key > 47 && key < 58) e.preventDefault();
    };

    return (
        <>
            {componentData.filterLabel && (
                <>
                    <div className="baby-name-finder">
                        <div className="calculator-body">
                            <div className="goals-section">
                                <div className="goals">
                                    <div className="container">
                                        <ul>
                                            {componentData.searchTabs.length > 0 &&
                                                componentData.searchTabs.map((item, index) => {
                                                    return (
                                                        <li
                                                            className={`${
                                                                item.fields.key.value === selectedTab.key
                                                                    ? "active"
                                                                    : ""
                                                                }`}
                                                            onClick={() => setTab(item.fields)}
                                                            key={item.fields.key.value}
                                                        >
                                                            <span className="heading">
                                                                {item.fields.name.value}
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="container">
                                <div className="form-section">
                                    <div className="nameSearchWrapper">
                                        {!isMobile && (
                                            <p className="nameSearchFieldHeading">
                                                {componentData.searchByLabel.value}
                                            </p>
                                        )}
                                        <div className="nameSearchFieldWrapper">
                                            <div className="showFirstNameWrapper">
                                                {tabData.showFirstNameForm ? (
                                                    <FirstNameForm
                                                        tabData={tabData}
                                                        getSearchType={getSearchType}
                                                        getSearchText={getSearchText}
                                                        componentData={componentData}
                                                        getGenderFilters={getGenderFilters}
                                                        getOriginFilters={getOriginFilters}
                                                        clearTextWithResult={clearTextWithResult}
                                                        getAutoSuggestNames={getAutoSuggestNames}
                                                        autoNames={autoNames}
                                                        paginate={paginate}
                                                        rendering={props.rendering}
                                                        itemid={props.itemid}
                                                    />
                                                ) : (
                                                        <>
                                                            <div className="showMiddleNameWrapper">
                                                                {tabData.showMiddleNameForm && (
                                                                    <FirstNameForm
                                                                        tabData={tabData}
                                                                        getSearchType={getSearchType}
                                                                        getSearchText={getSearchText}
                                                                        componentData={componentData}
                                                                        getGenderFilters={getGenderFilters}
                                                                        getOriginFilters={getOriginFilters}
                                                                        clearTextWithResult={clearTextWithResult}
                                                                        getAutoSuggestNames={getAutoSuggestNames}
                                                                        autoNames={autoNames}
                                                                        paginate={paginate}
                                                                        rendering={props.rendering}
                                                                        itemid={props.itemid}
                                                                    />
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                <div className="babyNameFilterByWrapper">
                          {/* {!isMobile && ( */}
                            <div className={!isMobile?"filterByTextContainer":"d-none"}>
                              <p className="filterByText">
                                {componentData.filterLabel.value}
                              </p>
                            </div>
                          {/* )} */}
                          {/* Gender Filter Work around */}
                          <div className="filterByOptionContainer filterByGenderContainer">
                            <div className="nameSearchFilterDropdown">
                              <div className="custom-select-dropdown">
                                <div className="select-box--box">
                                  <div className="select-box--container">
                                    <div
                                      className={
                                        genderFilterList.length > 0
                                          ? "select-box--selected-item-gender border-highlighted"
                                          : "select-box--selected-item-gender"
                                      }
                                      onClick={dropDown}
                                    >
                                      {defaultGenderPlaceHolder}
                                    </div>
                                    <div
                                      className="select-box--arrow"
                                      name="select-box--name"
                                      onBlur={closeDropDown}
                                    >
                                      <span
                                        name="drop-down-arrow"
                                        className={`${
                                          showItems
                                            ? "select-box--arrow-up fa fa-angle-up"
                                            : "select-box--arrow-down fa fa-angle-down"
                                        }`}
                                      ></span>
                                    </div>
                                    <div
                                      style={{
                                        display: showItems ? "block" : "none",
                                      }}
                                      className="select-box--items"
                                    >
                                      {genderItem.map((item, index) => {
                                        return (
                                          <div
                                            key={index}
                                            onClick={() => selectItem(item)}
                                            className={
                                              defaultGenderPlaceHolder ===
                                              item.fields.name.value
                                                ? "selected"
                                                : ""
                                            }
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                item.fields.selectbyDefault
                                                  .value
                                              }
                                              readOnly
                                              className="custom-checkbox"
                                              disabled={
                                                item.fields.count === 0 ||
                                                item.fields.count === undefined
                                              }
                                            />
                                            <p
                                              className={
                                                item.fields.count === 0 ||
                                                item.fields.count === undefined
                                                  ? "nameListItem nameListItem-disabled"
                                                  : "nameListItem"
                                              }
                                            >
                                              {item.fields.name.value}{" "}
                                              <span>
                                                {`(${item.fields.count})`}
                                              </span>
                                            </p>
                                          </div>
                                        );
                                      })}
                                      <div className="button-container">
                                        <button
                                          onClick={clearAllGender}
                                          className="btn btn-clear"
                                          disabled={
                                            genderFilterList.length === 0
                                          }
                                        >
                                          {t("Common_ClearAll")}
                                        </button>
                                        <button onClick={closeDropDown} className="btn btn-primary">{t('Common_Done')}</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Origin Filter Work Around */}
                          <div className="filterByOptionContainer filterByOriginContainer">
                            <div className="nameSearchFilterDropdown">
                              <div className="custom-select-dropdown">
                                <div className="select-box--box">
                                  <div className="select-box--container">
                                    <div
                                      className={
                                        originFilterList.length > 0
                                          ? "select-box--selected-item-origin border-highlighted"
                                          : "select-box--selected-item-origin"
                                      }
                                      onClick={originDropDown}
                                    >
                                      {defaultSearchType}
                                    </div>
                                    <div
                                      className="select-box--arrow"
                                      name="select-box--name"
                                      onBlur={closeOriginDropDown}
                                    >
                                      <span
                                        name="drop-down-arrow"
                                        className={`${
                                          showOriginItems
                                            ? "select-box--arrow-up fa fa-angle-up"
                                            : "select-box--arrow-down fa fa-angle-down"
                                        }`}
                                      ></span>
                                    </div>
                                    <div
                                      style={{
                                        display: showOriginItems
                                          ? "block"
                                          : "none",
                                      }}
                                      className="select-box--items"
                                    >
                                      <div className="origin-filter-search-box">
                                        <div className="origin-search-filter-field">
                                          <input
                                            className="origin-search-filter"
                                            type="text"
                                            value={originString}
                                            placeholder={"Search"}
                                            onChange={(e) => handleChange(e)}
                                            onKeyPress={restrictSpecialChar}
                                          />
                                          <button
                                            className="btn origin-search-btn"
                                            disabled
                                          >
                                            <i
                                              className="fa fa-search origin-search-icon"
                                              aria-hidden="true"
                                            ></i>
                                          </button>
                                        </div>
                                      </div>
                                      <section className="origin-filter-fields-wrapper">
                                        {originItem.map((item, index) => {
                                          if (
                                            ((item.fields.count != null ||
                                              item.fields.count != undefined) &&
                                              originString.length <= 2) ||
                                            (originString.length > 2 &&
                                              item.fields.name.value
                                                .toLowerCase()
                                                .startsWith(
                                                  originString.toLowerCase()
                                                ))
                                          ) {
                                            return (
                                              <div
                                                key={index}
                                                onClick={() =>
                                                  selectOriginItem(item)
                                                }
                                                className={
                                                  defaultSearchType ===
                                                  item.fields.name.value
                                                    ? "selected"
                                                    : ""
                                                }
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    item.fields.selectbyDefault
                                                      .value
                                                  }
                                                  readOnly
                                                  className="custom-checkbox"
                                                  disabled={
                                                    item.fields.count === 0
                                                  }
                                                />
                                                <p
                                                  className={
                                                    item.fields.count === 0
                                                      ? "nameListItem nameListItem-disabled"
                                                      : "nameListItem"
                                                  }
                                                >
                                                  {item.fields.name.value}{" "}
                                                  <span>
                                                    {`(${item.fields.count})`}
                                                  </span>
                                                </p>
                                              </div>
                                            );
                                          }
                                        })}
                                      </section>
                                      <div className="button-container">
                                        <button
                                          onClick={clearAllOrigins}
                                          className="btn btn-clear"
                                          disabled={
                                            originFilterList.length === 0
                                          }
                                        >
                                          {t("Common_ClearAll")}
                                        </button>
                                        <button onClick={closeOriginDropDown} className="btn btn-primary">{t('Common_Done')}</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {showMiddleNameDesc && (
                                <div className="container middleNameMessageWrapper ">
                                    <p className="sorry-message-text">
                                        {componentData.searchTabs[1].fields.description1.value}
                                    </p>
                                    <p className="sorry-message-text">
                                        {componentData.searchTabs[1].fields.description2.value}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="social-share-container">
                            <div className="container">
                                <Placeholder
                                    name="social-share"
                                    rendering={props.rendering}
                                    itemid={props.itemid}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className="container">
                <div className="babyfilterValueConatiner babyfilterSearchBarConatiner ">
                    {genderFilterData &&
                        genderFilterData.length > 0 &&
                        genderFilterData.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className="filterValueWrapper"
                                    onClick={() => removeGenderItem(item)}
                                >
                                    <p className="filterValueText">{item.fields.name.value}</p>
                                    <i className="fa fa-times"></i>
                                </div>
                            );
                        })}
                    {originFilterData &&
                        originFilterData.length > 0 &&
                        originFilterData.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className="filterValueWrapper"
                                    onClick={() => removeOriginItem(item)}
                                >
                                    <p className="filterValueText">{item.fields.name.value}</p>
                                    <i className="fa fa-times"></i>
                                </div>
                            );
                        })}
                    {((genderFilterData && genderFilterData.length > 0) ||
                        (originFilterData && originFilterData.length > 0)) && (
                            <div className="filters-bar" onClick={clearAllFilters}>
                                <p className="clear-filter-Bar">{t("Common_ClearAll")} </p>
                            </div>
                        )}
                </div>
            </div>
            {loader ? (
                <Loader />
            ) : (
                    <>
                        {hideResult && (
                            <Results
                                isFullMatch={apidata.data.isFullMatch}
                                resultData={apidata.result}
                                paginate={paginate}
                                paginatedata={apidata}
                                pageSize={pageSize}
                                itemsperpage={itemsperpage}
                                searchtext={searchfieldText.text}
                                filters={apidata.filtergroup}
                                resultfilterlist={filterlist}
                                searchData={searchTypeResulMsg}
                                componentData={componentData}
                                tabData={tabData}
                                rendering={props.rendering}
                                itemid={props.itemid}
                            />
                        )}
                    </>
                )}
        </>
    );
};

export default withTranslation()(BabyNameSearchResult);
